export default __webpack_public_path__ + "static/media/b0e2852fdd9f053c87dd855037c72e90.png";